module.exports = __webpack_public_path__ + "static/media/User.c5855e8f.svg";